// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1__d9a52fee9b7fe3bea307","cls2":"UserCard-cls2___1ece33d204647fe3ff3 UserCard-cls1__d9a52fee9b7fe3bea307"};